import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107102Status: 'idle',
    startProcess107102Error: undefined as any,
    loadUserParamsProcess107102Status: 'idle',
    loadUserParamsProcess107102Error: undefined as any,

    process107102List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107102 = createAsyncThunk('process107102Slice/startProcess107102', async ({ process107102 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107102/`,
        prepareData(process107102),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107102Status } = getState().process107102Slice
        return startProcess107102Status !== 'pending'
    }
})

export const loadUserParamsProcess107102 = createAsyncThunk('process107102Slice/loadUserParamsProcess107102', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107102/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107102Status } = getState().process107102Slice
        return loadUserParamsProcess107102Status !== 'pending'
    }
})

const Process107102Slice = createSlice({
    name: 'process107102Slice',
    initialState,
    reducers: {
        resetstartProcess107102: (state) => {
            state.job = undefined
            state.startProcess107102Error = undefined
        },
        resetstartProcess107102Error: (state) => {
            state.startProcess107102Error = undefined
        },
        resetloadUserParamsProcess107102: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107102Error = undefined
        },
        resetloadUserParamsProcess107102Error: (state) => {
            state.loadUserParamsProcess107102Error = undefined
        },
        removeFromProcess107102ListById: (state, action) => {
            state.process107102List = state.process107102List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107102ListByIds: (state, action) => {
            state.process107102List = state.process107102List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107102List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107102Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107102List = []
            state.startProcess107102Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107102.pending, (state) => {
            state.startProcess107102Status = 'pending'
            state.startProcess107102Error = undefined
        })
        builder.addCase(startProcess107102.fulfilled, (state, action) => {
            state.startProcess107102Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107102.rejected, (state, action) => {
            state.startProcess107102Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107102Error = action.error.message
            } else {
                state.startProcess107102Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107102.pending, (state) => {
            state.loadUserParamsProcess107102Status = 'pending'
            state.loadUserParamsProcess107102Error = undefined
        })
        builder.addCase(loadUserParamsProcess107102.fulfilled, (state, action) => {
            state.loadUserParamsProcess107102Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107102.rejected, (state, action) => {
            state.loadUserParamsProcess107102Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107102Error = action.error.message
            } else {
                state.loadUserParamsProcess107102Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107102,
    resetstartProcess107102Error,
    resetloadUserParamsProcess107102,
    resetloadUserParamsProcess107102Error,
    removeFromProcess107102ListById,
    removeFromProcess107102ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107102Slice.actions
export default Process107102Slice.reducer
